export const BODY_REFS = {
  shoulderX: 0.323299,
  hipX: 0.287169,
};
